import { Component, OnInit, Input } from "@angular/core";
import { first } from "rxjs/operators";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { Employee } from "../../core/model/employee/employee";
import { UserProfile } from "../../core/model/user-profile";
import { DesactiverEmployee } from "../../core/model/employee/desactiver-employee";
import { EmployeeService } from "../../core/service/employee.service";
import { UserProfileService } from "../../core/service/user-profile.service";

@Component({
  selector: "app-desactiver-user",
  templateUrl: "./desactiver-user.component.html",
  styleUrls: ["./desactiver-user.component.scss"],
})
export class DesactiverUserComponent implements OnInit {
  form2: FormGroup;
  pressButton: Boolean = false;
  erreur: String = "";

  @Input() employeeId;

  employee: Employee;
  employees: Employee[];
  userprofiles: UserProfile[];

  desactiverEmployee: DesactiverEmployee = new DesactiverEmployee();

  constructor(
    private _employeeService: EmployeeService,
    private _userProfileService: UserProfileService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      roleAffected: [null, Validators.compose([Validators.required])],
      userAffected: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getEmployeeById(this.employeeId);
    this.getUserProfil();
  }

  getEmployeeById(employeeId) {
    this._employeeService.getEmployeeById(employeeId).subscribe(
      (data) => {
        this.employee = data;
        this.desactiverEmployee.username = this.employee.username;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUserProfil() {
    this._userProfileService.getUserProfiles().subscribe(
      (data) => {
        this.userprofiles = data.sort((a, b) =>
          a.description > b.description ? 1 : -1
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUsers() {
    const roleName = this.form2.controls["roleAffected"].value;
    this._employeeService.getEmployeeByProfile(roleName).subscribe(
      (data) => {
        this.employees = data.sort((a, b) => (a.id > b.id ? 1 : -1));
        this.form2.controls["userAffected"].setValue(
          data[data.length - 1].username
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.spinner.show();
    this.pressButton = true;

    this.desactiverEmployee.backupUsername =
      this.form2.controls["userAffected"].value;

    this._employeeService
      .desactiver(this.desactiverEmployee)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          this.erreur = error.error;;
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
